const isFunctionType = (type) => {
  return typeof type === 'function'
}

const isBooleanType = (type) => {
  return typeof type === 'boolean'
}

const isNumberType = (type) => {
  return typeof type === 'number'
}

const isStringType = (type) => {
  return typeof type === 'string'
}

const isStringifiedJSON = (str) => {
  try {
    JSON.parse(str)
    return typeof str === 'string'
  } catch (e) {
    return false
  }
}
export {
  isFunctionType,
  isBooleanType,
  isNumberType,
  isStringType,
  isStringifiedJSON
}
